module.exports = __webpack_public_path__ + "img/banner5.6e419634.png";